interface ToastOptions {
  type: string
  title: string
  text: string
  timeout?: number
  i18nOptions?: object
}

/**
 * @function useToastComposable
 * @description This function provides a composable hook to show a toast (Wrapper on top of AlertLayer.vue)
 *
 * @returns {object} An object with a method to show a toast
 *
 * @example
 *
 * const { showToast } = useToastComposable()
 * showToast({ type: "info", title: "Title", text: "Text" })
 *
 */
export default function useToastComposable({
  i18n,
  store,
}: {
  i18n: any
  store: any
}) {
  const scope = {
    /**
     * @function showToast
     * @description Dispatches an alert action to show a toast.
     *
     * @param {ToastOptions} [toastOptions] An object with the toast options
     * @param {string} [toastOptions.type] The type of the toast. Can be "info" or "success".
     * @param {string} [toastOptions.title] The title of the toast.
     * @param {string} [toastOptions.text] The text of the toast.
     */
    showToast(
      { type, title, text, timeout, i18nOptions }: ToastOptions = {
        type: 'info',
        title: '',
        text: 'Text',
        timeout: 3000,
        i18nOptions: {},
      }
    ) {
      store.dispatch('alert/addAlert', {
        type,
        title: title || i18n.t(`alert_toast.titles.${type}`),
        text,
        timeout,
        i18nOptions,
      })
    },
    showToastCrudRemoveSuccess(title: string, isSuccess: boolean) {
      scope.showToast({
        type: isSuccess ? 'info' : 'warning',
        title: title,
        text: `crud_operation_messages.remove_${
          isSuccess ? 'success' : 'fail'
        }`,
        timeout: 2000,
      })
    },
  }
  return scope
}
